// Fila de una cita virtual en la Sala del médico (Sala CRM↔HCE, rebanada 8b; PLAN 4.10): insignia «Virtual», fecha y hora exacta de la cita (reloj de
// Ecuador), y los botones de telemedicina — Conectar / Volver a entrar, Finalizar consulta y No asistió. Una virtual NO usa Llamar ni «En sala».
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { EtiquetaVirtual } from './EtiquetaVirtual';
import { TableCell, TableRow } from '@/components/ui/table';
import { horaEcuadorDe } from '@/lib/salaHce';
import { accionesDeVirtual, fechaEcuadorDe, type AccionVirtual, type CitaVirtual } from '@/lib/telemedicinaHce';

export function FilaVirtual({
  cita,
  ahoraSrvMs,
  ocupada,
  onAccion,
}: {
  cita: CitaVirtual;
  /** Hora del servidor ahora (ms epoch), o `null` si todavía no se conoce. */
  ahoraSrvMs: number | null;
  ocupada: boolean;
  onAccion: (c: CitaVirtual, a: AccionVirtual) => void;
}): JSX.Element {
  const { t } = useTranslation();
  const acciones = accionesDeVirtual(cita, ahoraSrvMs);
  return (
    <TableRow data-virtual="true" data-estado={cita.estado} data-sesion-terminada={cita.sesionTerminada ? 'true' : undefined}>
      <TableCell className="font-mono text-xs">—</TableCell>
      <TableCell className="text-hce-ink">
        <div className="font-medium">{cita.pacienteNombre}</div>
        <div className="mt-1 flex flex-wrap gap-1">
          <EtiquetaVirtual />
        </div>
        {cita.sesionTerminada && <div className="mt-1 text-xs text-amber-700">{t('sala.virtual.sesionTerminada')}</div>}
      </TableCell>
      <TableCell className="whitespace-nowrap font-mono text-xs">
        {fechaEcuadorDe(cita.inicio)} {horaEcuadorDe(cita.inicio)}
      </TableCell>
      <TableCell className="text-hce-muted">{cita.motivo ?? '—'}</TableCell>
      <TableCell className="whitespace-nowrap font-mono text-xs">—</TableCell>
      <TableCell className="whitespace-nowrap text-xs">{cita.ordenEnviada ? t('sala.marca.ordenEnviada') : cita.estado === 'en_consulta' ? t('sala.estado.in_consult') : t('sala.estado.programada')}</TableCell>
      <TableCell>
        <div className="flex flex-wrap gap-1.5">
          {acciones.map((a) => (
            <Button
              key={a}
              size="sm"
              variant={a === 'conectar' || (a === 'finalizar' && cita.sesionTerminada) ? 'default' : a === 'noAsistio' ? 'ghost' : 'outline'}
              disabled={ocupada}
              aria-label={t('sala.accion.de', { accion: t(`sala.virtual.accion.${a}`), nombre: cita.pacienteNombre })}
              onClick={() => onAccion(cita, a)}
            >
              {t(`sala.virtual.accion.${a}`)}
            </Button>
          ))}
        </div>
      </TableCell>
    </TableRow>
  );
}
